<template>
    <div ref="editor"></div>
</template>

<script>
    export default {
        props: {
            modelValue: {
                type: String,
                default: () => {},
            },
            hasError: {
                type: Boolean,
                default: false,
            },
            variant: {
                type: String,
                default: 'default',
            },
        },
        data() {
            return {
                editor: null,
            };
        },
        mounted() {
            const Quill = require('quill');
            this.editor = new Quill(this.$refs.editor, {
                modules: {
                    toolbar: this.toolbarOptions,
                },
                formats: this.formatOptions,
                theme: 'snow',
            });

            this.editor.root.innerHTML = this.modelValue;

            this.editor.on('text-change', () => this.update());
        },
        computed: {
            toolbarOptions: function () {
                if (this.variant === 'default') {
                    return [
                        [{ header: 1 }, { header: 2 }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ script: 'sub' }, { script: 'super' }],
                        [{ indent: '-1' }, { indent: '+1' }], 
                        [{ align: [] }],
                        ['link', 'image'],
                        ['clean'], 
                    ];
                }
            },
            formatOptions: function() {
                if (this.variant === 'default') {
                    return [
                        'bold', 
                        'underline', 
                        'italic',
                        'strike',
                        'link',
                        'script',
                        'header', 
                        'list',
                        'align',
                        'indent',
                        'direction',
                        'image',
                    ];
                }
            },
        },
        methods: {
            update() {
                this.$emit('update:modelValue', this.editor.getText() ? this.editor.root.innerHTML : '');
            },
        },
    }
</script>